import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ButtonControlService {

    private $botonSiguiente: Subject<boolean> = new Subject<boolean>();
    private destroy$ = new Subject();
    public botonSiguiente: Observable<boolean> = this.$botonSiguiente.asObservable().pipe(takeUntil(this.destroy$));

    constructor() { }

    public cambiarBotonSiguiente(input: boolean) {
        this.$botonSiguiente.next(input);
    }

    public stopSubscriptions() {
        this.destroy$.next();
    }
}
